class ContactAccordion extends HTMLElement {
  constructor() {
    super();
    this.tabButtons = this.querySelectorAll('.contact-tabs__tab-button');
    this.contentTabs = this.querySelectorAll('.contact-tab__tab');
    this.browserWidth = window.innerWidth;
    this.init();
  }

  init() {
    this.addEventListener('click', event => this.handleClick(event));

    this.handleBrowserWidth()
    window.addEventListener('resize', () => this.handleBrowserWidth());

    // A link can open a tab by its title, e.g. /pages/contact#faqs or #delivery-returns (the footer links)
    this.openTabFromHash();
    window.addEventListener('hashchange', () => this.openTabFromHash());

    // A link to the tab already in the address fires no hashchange, so open it directly.
    // Deferred, so it runs after the accordion's own click-outside has closed the open tab.
    document.addEventListener('click', event => {
      const link = event.target.closest('a[href*="#"]');
      if (link && link.pathname === window.location.pathname && link.hash === window.location.hash) {
        setTimeout(() => this.openTabFromHash());
      }
    });
  }

  closeTab(tab) {
    const tabAccordion = tab.querySelector('.accordion__item');
    const tabContent = tab.querySelector('.accordion__content');
    tabAccordion.classList.remove('accordion__item--open');
    tabContent.removeAttribute('style');
  }

  handleBrowserWidth() {
    const newWidth = window.innerWidth;

    if ((this.browserWidth > 989 && newWidth < 990) || (this.browserWidth < 990 && newWidth > 989)) {
      this.contentTabs.forEach(tab => this.closeTab(tab));
      this.tabButtons.forEach(button => button.classList.remove('contact-tabs__tab-button--active'));
    }
    this.browserWidth = newWidth;

    // Only when no tab is showing: resize also fires on scroll in iPad Safari, and used to reopen the first tab under the chosen one
    if (this.browserWidth > 989 && !this.querySelector('.contact-tabs__tab-button--active')) {
      this.showTab(this.tabButtons[0].dataset.title);
    }
  }

  handleClick(event) {
    const clickedButton = event.target.closest('.contact-tabs__tab-button');
    if (clickedButton) {
      this.showTab(clickedButton.dataset.title);
      this.setHash(clickedButton.dataset.title);
      return;
    }

    // Below 990 each tab is an accordion: its own header, not the questions inside it
    const header = event.target.closest('.accordion__header');
    const item = header && header.parentElement;
    const tab = item && item.parentElement.parentElement;
    if (tab && tab.classList.contains('contact-tab__tab') && !item.classList.contains('accordion__item--open')) {
      this.setHash(tab.dataset.title);
    }
  }

  // Keep the address on the tab being shown, so it can be shared or reloaded,
  // and so a footer link to another tab still counts as a change
  setHash(title) {
    if (window.location.hash.slice(1) === title) return;
    history.replaceState(history.state, '', '#' + title);
  }

  showTab(activeTitle) {
    this.tabButtons.forEach(tabButton => {
      tabButton.classList.toggle('contact-tabs__tab-button--active', tabButton.dataset.title === activeTitle);
    });

    this.contentTabs.forEach(tab => {
      const tabContent = tab.querySelector('.accordion__item');
      tabContent.classList.toggle('accordion__item--open', tab.dataset.title === activeTitle);
    });
  }

  openTabFromHash() {
    const title = decodeURIComponent(window.location.hash.slice(1)).toLowerCase();
    const tab = [...this.contentTabs].find(tab => tab.dataset.title === title);
    if (!tab) return;

    if (window.innerWidth > 989) {
      this.showTab(title);
      this.revealIfOffscreen(this);
      return;
    }

    // Below 990 the tabs are a stack of accordions
    const item = tab.querySelector('.accordion__item');
    customElements.whenDefined('accordion-wrapper').then(() => {
      if (!item.classList.contains('accordion__item--open')) customElements.get('accordion-wrapper').openAccordion(item);
      this.revealIfOffscreen(tab);
    });
  }

  // The footer links are far down the page, so on the contact page itself the tab would open out of sight
  revealIfOffscreen(el) {
    const top = el.getBoundingClientRect().top;
    const header = document.querySelector('.header-wrapper');
    const headerHeight = header ? header.offsetHeight : 0;
    if (top >= headerHeight && top < window.innerHeight * 0.6) return;

    window.scrollTo({ top: top + window.scrollY - headerHeight - 16, behavior: 'smooth' });
  }
}

customElements.define("contact-accordion", ContactAccordion);
